import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as bulkImportTemplateTypeState from '../static-data.reducer';
import * as bulkImportTemplateTypeReducer from '../reducers/bulk-import-template-types.reducer';

export const selectBulkImportTemplateTypes = createSelector(
  bulkImportTemplateTypeState.selectBulkImportTemplateTypeState,
  bulkImportTemplateTypeReducer.getBulkImportTemplateTypeResponse
);
